import React from 'react';
/**
 *  CnListPro组件的上下文
 */
export var CnListProContext = React.createContext({});
